import React, { useState } from "react";
import StyledModal from "../components/StyledComponents/StyledModal";
import StyledText from "../components/StyledComponents/StyledText";
import styled from "styled-components";
import { media, passwordValidationRules,passwordUpdationValidationRules, validateForm } from "../utils/helper";
import StyledInput from "../components/StyledComponents/StyledInput";
import StyledButton from "../components/StyledComponents/StyledButton";
import { Form } from "react-bootstrap";
import ResetPasswordIcon from "../assets/svgIcons/ResetPasswordIcon";
import { toast } from "react-toastify";
import { useResetPasswordMutation } from "../services/apis";

const LoggedInResetPassword = ({ show, onHide }) => {
  const [resetPassword, { isLoading }] = useResetPasswordMutation();
  const [errors, setErrors] = useState({});
  const formDefault = {
    oldPassword: "",
    newPassword: "",
    confirmPassword: "",
  }
  const [formData, setFormData] = useState(formDefault);
  
  const validationRules = {
    oldPassword: passwordValidationRules,
    newPassword: passwordUpdationValidationRules,
    confirmPassword: [
      ...passwordUpdationValidationRules,
      {
        condition: (value) => value !== formData.newPassword,
        message: "Passwords do not match",
      },
    ]
  };

  const handleInputChange = (fieldName, value) => {
    setErrors((prevErrors) => ({
      ...prevErrors,
      [fieldName]: "",
    }));
    setFormData((prevData) => ({
      ...prevData,
      [fieldName]: value,
    }));
  };

  const modalHide = () => {
    setFormData(formDefault);
    setErrors({});
    onHide();
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const validationErrors = validateForm(formData, validationRules);
    setErrors(validationErrors);

    if (Object.keys(validationErrors).length > 0) return;

    try {
      const { error } = await resetPassword({
        oldPassword: formData.oldPassword.trim(),
        newPassword: formData.newPassword.trim(),
        confirmPassword: undefined,
      });

      if (error) {
        toast.error(error?.data?.errorMessage ||
            error?.data?.errors?.[0]?.errorMessage ||
             "An unexpected error occurred.");
        return;
      }
      toast.success("Password updated successfully");
      modalHide();
    } catch (error) {
      console.error("Error submitting form:", error);
      toast.error("An unexpected error occurred. Please try again.");
    }
  };

  return (
    <StyledModal show={show} onHide={modalHide}>
      <StyledModalBody className="d-flex align-items-center justify-content-center flex-column gap-2 w-100">
        <ResetPasswordIcon />
        <StyledText $fontSize="1rem" $fontWeight="600" className="mt-3 mt-md-4">
          Change Your Password
        </StyledText>
        <Form
          noValidate
          onSubmit={handleSubmit}
          className="py-2 py-md-4 pb-md-5 w-100"
        >
          <StyledInput
            label="Old password"
            type="password"
            placeholder="Please enter your old password here"
            value={formData.oldPassword}
            onChange={(e) => handleInputChange("oldPassword", e.target.value)}
            required
            error={errors.oldPassword}
          />
          <StyledInput
            label="New password"
            type="password"
            placeholder="Please enter your new password here"
            value={formData.newPassword}
            onChange={(e) => handleInputChange("newPassword", e.target.value)}
            required
            error={errors.newPassword}
          />
          <StyledInput
            label="Confirm password"
            type="password"
            placeholder="Please retype your confirm password here"
            value={formData.confirmPassword}
            onChange={(e) =>
              handleInputChange("confirmPassword", e.target.value)
            }
            required
            error={errors.confirmPassword}
          />

          <StyledButton
            _variant="primaryGradiant"
            loading={isLoading}
            type="submit"
            className="w-100 p-3 mt-2 fw-semibold"
          >
            Update Password
          </StyledButton>
        </Form>
      </StyledModalBody>
    </StyledModal>
  );
};

const StyledModalBody = styled.div`
  max-width: 75%;
  ${media.xl`
       max-width : 100%;`}
`;
export default LoggedInResetPassword;
